const sustainabilityAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */
      //Smooth content

      ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 1,
        effects: true,
      });

         //Arrow button

      document.querySelector('button.arrow-btn').addEventListener('click', () => {
        gsap.to(window, { duration: 2, scrollTo: { y: ".intro", offsetY: 75 } });
      })
      
      //H1

      const h1 = document.querySelector("h1.title1");
      if (h1) {
        const h1Split = new SplitText(h1, {
          type: "lines,words,chars",
          linesClass: "split-line",
          charsClass: "js-char",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: h1,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
            markers: false,
          },
        });

        // 1. Animation d'apparition de chaque ligne (comme le span)
        tl.from(h1Split.lines, {
          yPercent: (i) => (i % 2 === 0 ? 100 : -100),
          opacity: 0,
          duration: 0.5,
          stagger: 0.2,
          ease: "power3.inOut",
        });

        // 2. Animation des caractères à l'intérieur de chaque ligne
        h1Split.lines.forEach((line, i) => {
          tl.from(
            line.querySelectorAll(".js-char"),
            {
              opacity: 0,
              yPercent: 20,
              duration: 0.8,
              stagger: 0.04,
              ease: "power3.inOut",
            },
            "-=0.7" // chevauche avec la fin de l'anim de la ligne
          );
        });
      }

      gsap.to(".rail", {
        xPercent: -50,
        ease: "none",
        duration: 30,
        repeat: -1,
      });

      //H2

      const h2Elements = document.querySelectorAll("h2");
      h2Elements.forEach((h2) => {
        const h2Split = new SplitText(h2, {
          type: "lines",
          linesClass: "split-child",
        });
        gsap.from(h2Split.lines, {
          duration: 2,
          yPercent: 100,
          ease: "power4",
          stagger: 0.1,
          scrollTrigger: {
            trigger: h2,
            start: "top 90%",
            //end: "+=100%",
            toggleActions: "play reverse play reverse",
          },
        });
      });

      //Intro section

      gsap.from(".intro .img-side", {
        scrollTrigger: {
          trigger: ".intro",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
      });

      gsap.from(".intro .txt-side p", {
        scrollTrigger: {
          trigger: ".intro",
          start: "top 80%",

          //end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: 200,
        opacity: 0,
      });

      //Mission 1 section
      gsap.from(".mission-1 .mission, .mission-1 .mission-link-container", {
        y: 100,
        opacity: 0,
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".mission-1",
          start: "top 80%",
          toggleActions: "play reverse play reverse",
          markers: false,
        },
      });


      //Mission 2 section
      gsap.from(".mission-2 .mission", {
        y: 100,
        opacity: 0,
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".mission-2",
          start: "top 80%",
          toggleActions: "play reverse play reverse",
          markers: false,
        },
      });

            //Support section

      gsap.from(".support .img-side", {
        scrollTrigger: {
          trigger: ".support",
          start: "top 80%",

          end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: 200,
        opacity: 0,
      });

      gsap.from(".support .txt-side p", {
        scrollTrigger: {
          trigger: ".support",
          start: "top 80%",

          //end: "+=100%",
          markers: false,
          toggleActions: "play reverse play reverse",
        },
        x: -200,
        opacity: 0,
      });


      const arrowBtns = document.querySelectorAll(".arrow-btn-cards");
      const cardBtns = document.querySelectorAll(".card");
      const progressSteps = document.querySelectorAll(".progress-step");
      let currentCard = 0;
      let dir = 1;
      moveCards();

      function updateProgressBar() {
        progressSteps.forEach((step, index) => {
          if (index < currentCard) {
            step.classList.add("completed");
            step.classList.remove("active");
          } else if (index === currentCard) {
            step.classList.add("active");
            step.classList.remove("completed");
          } else {
            step.classList.remove("active");
            step.classList.remove("completed");
          }
        });
      }

      // Initialize the first step as active
      updateProgressBar();

      arrowBtns.forEach((btn, i) => {
        btn.onpointerenter = (e) =>
          gsap.to(btn, {
            ease: "expo",
            "box-shadow": "0 3px 4px #00000050",
          });

        btn.onpointerleave = (e) =>
          gsap.to(btn, {
            ease: "expo",
            "box-shadow": "0 6px 8px #00000030",
          });

        btn.onclick = (e) => {
          dir = i == 0 ? 1 : -1;
          if (i == 0) {
            currentCard--;
            currentCard = Math.max(0, currentCard);
          } else {
            currentCard++;
            currentCard = Math.min(7, currentCard);
          }
          moveCards(0.75);
        };
      });

      cardBtns.forEach((btn, i) => {
        btn.onpointerenter = (e) =>
          gsap.to(btn, {
            ease: "power3",
            overwrite: "auto",
            "box-shadow": () =>
              i == currentCard
                ? "0 6px 11px #00000030"
                : "0 6px 11px #00000030",
          });

        btn.onpointerleave = (e) =>
          gsap.to(btn, {
            ease: "power3",
            overwrite: "auto",
            "box-shadow": () =>
              i == currentCard ? "0 6px 11px #00000030" : "0 0px 0px #00000030",
          });

        btn.onclick = (e) => {
          dir = i < currentCard ? 1 : -1;
          currentCard = i;
          moveCards(0.75);
        };
      });

      function moveCards(dur = 0) {
        document.querySelectorAll(".card").forEach((card, idx) => {
          if (idx === currentCard) {
            card.classList.add("active");
          } else {
            card.classList.remove("active");
          }
        });
        gsap
          .timeline({
            defaults: {
              duration: dur,
              ease: "power3",
              stagger: { each: -0.03 * dir },
            },
          })
          .to(
            ".card",
            {
              x: -400 * currentCard,
              y: (i) => (i == currentCard ? 0 : 15),
              height: (i) => (i == currentCard ? 300 : 300),
              ease: "elastic.out(0.4)",
            },
            0
          )
          .to(
            ".card",
            {
              cursor: (i) => (i == currentCard ? "default" : "pointer"),
              "box-shadow": (i) =>
                i == currentCard
                  ? "0 6px 11px #00000030"
                  : "0 0px 0px #00000030",
              /* border: (i) =>
                i == currentCard ? "2px solid #26a" : "0px solid #fff", */
              background: (i) => (i == currentCard ? "#011D3F" : "#23e2be"),
              ease: "expo",
            },
            0
          )
          /* .to(
            ".icon svg",
            {
              attr: {
                stroke: (i) => (i == currentCard ? "transparent" : "#36a"),
                fill: (i) => (i == currentCard ? "#36a" : "transparent"),
              },
            },
            0
          ) */
          .to(
            ".arrow-btn-cards-prev",
            {
              autoAlpha: currentCard == 0 ? 0 : 1,
            },
            0
          )
          .to(
            ".arrow-btn-cards-next",
            {
              autoAlpha: currentCard == 6 ? 0 : 1,
            },
            0
          )
          .to(
            ".card h4",
            {
              //y: (i) => (i == currentCard ? 0 : 8),
              opacity: (i) => (i == currentCard ? 1 : 0.8),
              color: (i) => (i == currentCard ? "#23e2be" : "#011D3F"),
            },
            0
          )
          .to(
            ".card",
            {
              onUpdate: function () {
                document.querySelectorAll(".card").forEach((card, idx) => {
                  const color = idx === currentCard ? "#fff" : "#011D3F";
                  card.querySelectorAll("p, li").forEach((el) => {
                    el.style.color = color;
                  });
                });
              },
            },
            0
          );

        updateProgressBar();
      }
    });
  },
};

export default sustainabilityAnim;
